<div class="modal-body">

    <rask-list [data]="kontrakt" [useClientFilter]="true">
        <rask-list-column header="Kontraktnummer" field="kontraktnummer" [sortable]="true" width="90px">
            <ng-template let-row="row">
                <a  target="_blank"
                    [routerLink]="['/virkeskop/avtal/', row.avtalId]"
                    [queryParams]="{ kontraktId: row.kontraktId}">
                    {{ row.kontraktnummer }}
                    <i class="fa-regular fa-up-right-from-square"></i>
                </a>
            </ng-template>
        </rask-list-column>

        <rask-list-column header="Benämning" field="benamning" [sortable]="true"></rask-list-column>
        <rask-list-column header="Affärsform" field="affarsform" [sortable]="true"></rask-list-column>
        <rask-list-column header="Status" field="status" [sortable]="true"></rask-list-column>
        <rask-list-column header="Virkeskopare" field="ansvarigVirkeskopare" [sortable]="true"></rask-list-column>
        <rask-list-column header="Kontrakt from" field="kontraktGiltigtFrom" [sortable]="true" ></rask-list-column>
        <rask-list-column header="Kontrakt tom" field="kontraktGiltigtTom" [sortable]="true" ></rask-list-column>
        <rask-list-column header="Skickad vacs" field="skickadTillVacs" [sortable]="true" ></rask-list-column>
        <rask-list-column header="Vacs avraknat" field="vacsAvraknatDatum" [sortable]="true" ></rask-list-column>
        <rask-list-column header="AO Beteckningar" field="aoBeteckningar" [sortable]="true"></rask-list-column>
        <rask-list-column header="Slutrapporterad" field="slutrapporteradDatum" [sortable]="true" ></rask-list-column>
        <rask-list-column header="Transport avslutad" field="transportAvslutadDatum" [sortable]="true" ></rask-list-column>
        <rask-list-column header="Produktion godkand" field="produktionGodkandDatum" [sortable]="true" ></rask-list-column>
        <rask-list-column header="Skotning avslutad" field="skotningAvslutadDatum" [sortable]="true" ></rask-list-column>
    </rask-list>
</div>

<div class="modal-footer">
    <rask-button color="secondary"
        (click)="onClose()"
        ngbAutofocus>
        Stäng
    </rask-button>
</div>